var map = {
	"./bounce/blocks": 2213,
	"./calc/blocks": 2214,
	"./craft/agent/blocks": 2216,
	"./craft/code-connection/blocks": 2217,
	"./craft/designer/blocks": 2077,
	"./craft/simple/blocks": 2215,
	"./dance/blocks": 1663,
	"./eval/blocks": 2218,
	"./flappy/blocks": 2219,
	"./jigsaw/blocks": 2225,
	"./maze/blocks": 2226,
	"./p5lab/spritelab/blocks": 1250,
	"./sites/studio/pages/blocks": 2240,
	"./studio/blocks": 2086,
	"./turtle/blocks": 2236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2704;